import React from 'react';
import { motion } from 'framer-motion';
import { AGREEXA_APP_URL } from '../lib/links';
import { Home, Hammer, Cpu, Zap, Droplets, Shield, Tent, Sun, Wrench, TreePine, Lightbulb } from 'lucide-react';
const categories = [{
  name: 'Smart Home',
  icon: Home,
  color: 'bg-blue-500/10 text-blue-500'
}, {
  name: 'Woodworking',
  icon: Hammer,
  color: 'bg-orange-500/10 text-orange-500'
}, {
  name: 'Electronics',
  icon: Cpu,
  color: 'bg-purple-500/10 text-purple-500'
}, {
  name: 'Solar DIY',
  icon: Sun,
  color: 'bg-yellow-500/10 text-yellow-500'
}, {
  name: '3D Printing',
  icon: Lightbulb,
  color: 'bg-pink-500/10 text-pink-500'
}, {
  name: 'Home Automation',
  icon: Zap,
  color: 'bg-indigo-500/10 text-indigo-500'
}, {
  name: 'Water Systems',
  icon: Droplets,
  color: 'bg-cyan-500/10 text-cyan-500'
}, {
  name: 'Home Security',
  icon: Shield,
  color: 'bg-red-500/10 text-red-500'
}, {
  name: 'Off Grid',
  icon: Tent,
  color: 'bg-green-500/10 text-green-500'
}, {
  name: 'Maker Tools',
  icon: Wrench,
  color: 'bg-gray-500/10 text-gray-500'
}, {
  name: 'Garden Projects',
  icon: TreePine,
  color: 'bg-emerald-500/10 text-emerald-500'
}];
export function FeaturedCategories() {
  return <section className="py-24 bg-soft dark:bg-navy-900 relative overflow-hidden" data-id="element-62">
      <div className="max-w-7xl mx-auto px-6" data-id="element-63">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-64">
          <div data-id="element-65">
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 dark:text-white mb-4" data-id="element-66">
              Explore by Category
            </h2>
            <p className="text-lg text-navy-700 dark:text-gray-400 max-w-2xl" data-id="element-67">
              From traditional woodworking to cutting-edge AI robotics, find
              your next obsession.
            </p>
          </div>
          <a href={AGREEXA_APP_URL} className="text-orange-500 font-semibold hover:text-orange-600 flex items-center gap-2" data-id="element-68">
            View All Categories <span aria-hidden="true" data-id="element-69">&rarr;</span>
          </a>
        </div>

        <div className="flex overflow-x-auto hide-scrollbar gap-4 pb-8 -mx-6 px-6 md:mx-0 md:px-0 md:grid md:grid-cols-4 lg:grid-cols-6" data-id="element-70">
          {categories.map((cat, index) => <motion.div key={cat.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} whileHover={{
          y: -5
        }} onClick={() => {
          window.location.href = AGREEXA_APP_URL;
        }} className="flex-shrink-0 w-32 md:w-auto flex flex-col items-center gap-4 p-6 rounded-2xl glass-card cursor-pointer group" data-id="element-71">
              <div className={`w-16 h-16 rounded-full flex items-center justify-center ${cat.color} group-hover:scale-110 transition-transform duration-300`} data-id="element-72">
                <cat.icon size={28} data-id="element-73" />
              </div>
              <span className="text-sm font-medium text-center text-navy-900 dark:text-gray-200" data-id="element-74">
                {cat.name}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}